import {object, string} from "yup";

export default object({
  app_id: string().required(),
  crypto_wallet_id: string().required(),
  description: string().max(15000)
});
